import { useEffect, useState } from "react";
import { deletePromoCode } from "../../api/promoCodes";
import { ConfirmDialog, Input } from "../../ui";
import "./styles.scss";

type DeletePromoCodeDialogProps = {
  promoCode: string;
  promoCodeId: string;
  isOpen: boolean;
  onClose: (update?: boolean) => void;
};

const DeletePromoCodeDialog = (props: DeletePromoCodeDialogProps) => {
  const [code, setCode] = useState("");

  useEffect(() => {
    if (props.isOpen) {
      setCode("");
    }
  }, [props.isOpen]);

  // A throw keeps the dialog open (wrong code, or the delete failed).
  const handleDelete = async () => {
    if (code !== props.promoCode) throw new Error("Promo code does not match");
    try {
      await deletePromoCode(props.promoCodeId);
    } catch (error) {
      console.error("Error deleting promo code:", error);
      throw error;
    }
  };

  return (
    <ConfirmDialog
      open={props.isOpen}
      onClose={(confirmed) => props.onClose(confirmed ? true : undefined)}
      onConfirm={handleDelete}
      title="Are you sure?"
      confirmLabel="Delete"
      confirmDisabled={code !== props.promoCode}
      message={
        <>
          <p>This action cannot be undone. If you delete this promo code, you will lose all details.</p>
          <p>Type the promo code to delete it</p>
        </>
      }
    >
      <Input
        className="delete-promo-code-dialog__input"
        value={code}
        placeholder={props.promoCode}
        aria-label="Type the promo code to delete it"
        onChange={(e) => setCode(e.target.value)}
      />
    </ConfirmDialog>
  );
};

export default DeletePromoCodeDialog;
